export default __webpack_public_path__ + "static/media/clientThree.c317ea41.jpg";